import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Grid, Box, CircularProgress, Avatar, useTheme } from '@mui/material';
import { useMain } from '../../hooks/useMain';
import { CurrencyRupee, ReceiptLong } from '@mui/icons-material';

const TotalBillAmount = ({ filterBy, startDate, endDate }) => {
  const [totalData, setTotalData] = useState(null);
  const [loading, setLoading] = useState(false);
  const { fetchtotalbillamount } = useMain();
  const theme = useTheme();

  useEffect(() => {
    const getTotalBillAmount = async () => {
      setLoading(true);
      const params = {};
      if (filterBy) params.filterBy = filterBy;
      if (filterBy === 'customDate' && startDate && endDate) {
        params.startDate = startDate;
        params.endDate = endDate;
      }
      try {
        const res = await fetchtotalbillamount(params);
        if (res.statusCode === 200) {
          setTotalData(res.data);
        }
      } catch (error) {
        console.error('Failed to fetch total bill amount:', error);
      } finally {
        setLoading(false);
      }
    };

    if (filterBy === 'customDate' && (!startDate || !endDate)) {
      return;
    }
    getTotalBillAmount();
  }, [filterBy, startDate, endDate, fetchtotalbillamount]);

  const StatCard = ({ title, value, icon: Icon, bgColor }) => (
    <Card
      sx={{
        bgcolor: bgColor,
        color: 'white',
        position: 'relative',
        overflow: 'hidden',
        borderRadius: 2,
        boxShadow: 3,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          right: -20,
          bottom: -20,
          opacity: 0.2,
          transform: 'rotate(-20deg)',
        }}
      >
        <Icon sx={{ fontSize: 100, color: 'white' }} />
      </Box>
      <CardContent>
        <Grid container alignItems="center" spacing={2}>
          <Grid item>
            <Avatar
              sx={{
                bgcolor: 'rgba(255, 255, 255, 0.2)',
                width: 56,
                height: 56,
              }}
            >
              <Icon sx={{ fontSize: 30, color: 'white' }} />
            </Avatar>
          </Grid>
          <Grid item>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, opacity: 0.9 }}>
              {title}
            </Typography>
            <Typography variant="h4" sx={{ fontWeight: 700 }}>
              {loading ? <CircularProgress size={30} sx={{ color: 'white' }} /> : value}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <StatCard
          title="Total Bill Amount"
          value={`₹${totalData?.amount?.toLocaleString('en-IN') || 0}`}
          icon={CurrencyRupee}
          bgColor={theme.palette.primary.main}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <StatCard
          title="Total Bills"
          value={totalData?.billCount?.toLocaleString('en-IN') || 0}
          icon={ReceiptLong}
          bgColor={theme.palette.secondary.main || '#28C76F'}
        />
      </Grid>
    </Grid>
  );
};

export default TotalBillAmount;